import React, { PureComponent } from 'react';
// utils
import T from 'prop-types';
// components
import ReactSwipe from 'react-swipe';
import StepTitle from './StepTitle';
import Icon from '../../../components/Icon/Icon';
// styles
import styles from './SlideshowStep.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class SlideshowStep extends PureComponent {
  constructor(props) {
    super(props);
    this.reactSwipe = React.createRef();
    this.state = {
      currentSlide: 0
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.listenKeyboard, true);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.listenKeyboard, true);
  }

  listenKeyboard = event => {
    if (event.keyCode === 39) {
      this.reactSwipe.current.next();
    }
    if (event.keyCode === 37) {
      this.reactSwipe.current.prev();
    }
  };

  next = () => {
    this.reactSwipe.current.next();
  };

  prev = () => {
    this.reactSwipe.current.prev();
  };

  handleSwipe = position => {
    this.setState({
      currentSlide: position
    });
  };

  render() {
    const {
      description,
      data: {
        content: { title, slides }
      }
    } = this.props;

    const { currentSlide } = this.state;

    const swipeOptions = {
      continuous: false,
      callback: this.handleSwipe,
      speed: 150
    };

    return (
      <div className={cn('container')}>
        <StepTitle title={title} description={description} />
        <div className={cn('wrapper')}>
          <div className={cn('navigation')}>
            <div className={cn('nav-wrapper')}>
              <div className={cn('nav-container')}>
                <div className={cn('nav')}>
                  <Icon
                    className={cn('icon', 'prev')}
                    type="chevron-up"
                    onClick={this.prev}
                  />
                  <span>{`${currentSlide + 1} / ${slides.length}`}</span>
                  <Icon
                    className={cn('icon', 'next')}
                    type="chevron-up"
                    onClick={this.next}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={cn('slide-wrapper')}>
            <ReactSwipe
              direction="vertical"
              className="swiper-container"
              ref={this.reactSwipe}
              swipeOptions={swipeOptions}
            >
              {slides.map((slide, index) => {
                const backgroundImage =
                  index <= currentSlide + 1 ? `url(${slide.image.url})` : '';
                return (
                  <div key={index}>
                    <div className={cn('slide')}>
                      <div className={cn('image-wrapper')}>
                        <div
                          onClick={this.next}
                          className={cn('image')}
                          style={{ backgroundImage }}
                        />
                      </div>
                      <p>{slide.description}</p>
                    </div>
                  </div>
                );
              })}
            </ReactSwipe>
          </div>
        </div>
      </div>
    );
  }
}

SlideshowStep.propTypes = {
  data: T.shape({
    content: T.shape({
      title: T.string.isRequired,
      slides: T.arrayOf(
        T.shape({
          image: T.shape({
            url: T.string.isRequired
          }),
          description: T.string.isRequired
        })
      )
    })
  })
};

export default SlideshowStep;



// WEBPACK FOOTER //
// ./src/containers/Module/components/SlideshowStep.jsx